import React from 'react';
export var HousePercent = function HousePercent() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.698 56.5946C124.897 83.9373 107.65 96.483 82.0527 106.131C56.455 115.78 27.436 101.436 17.2369 74.0929C7.03789 46.7502 24.5944 30.3643 50.1921 20.7159C75.7899 11.0676 104.499 29.2519 114.698 56.5946Z",
    fill: "#F9F9F9",
    stroke: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4983 49.5373L66.0529 17.2895L107.371 49.5373",
    stroke: "#333333",
    strokeWidth: "1.66",
    strokeLinecap: "round",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6458 53.4164L33.6473 96.0857L103.274 96.0858",
    stroke: "#333333",
    strokeWidth: "1.66",
    strokeLinecap: "round",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "0.83",
    y1: "-0.83",
    x2: "47.1225",
    y2: "-0.83",
    transform: "matrix(0.0142985 -0.999898 0.99981 0.0195056 99.7283 97.4847)",
    stroke: "#333333",
    strokeWidth: "1.66",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0413 61.5958H59.21C58.6577 61.5958 58.21 62.0435 58.21 62.5958V95.0858C58.21 95.6381 58.6577 96.0858 59.21 96.0858H80.0413C80.5936 96.0858 81.0413 95.6381 81.0413 95.0858V68.3678",
    stroke: "#333333",
    strokeWidth: "1.66",
    strokeLinecap: "round",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "72.2084",
    y1: "74.914",
    x2: "72.2084",
    y2: "84.2004",
    stroke: "#333333",
    strokeWidth: "1.66",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3006 32.7581C45.3006 33.2164 45.6722 33.5881 46.1306 33.5881C46.589 33.5881 46.9606 33.2164 46.9606 32.7581H45.3006ZM33.7953 42.9552V20.9432H32.1353V42.9552H33.7953ZM33.9653 20.7732H45.1306V19.1132H33.9653V20.7732ZM45.3006 20.9432V32.7581H46.9606V20.9432H45.3006ZM45.1306 20.7732C45.2245 20.7732 45.3006 20.8493 45.3006 20.9432H46.9606C46.9606 19.9326 46.1412 19.1132 45.1306 19.1132V20.7732ZM33.7953 20.9432C33.7953 20.8493 33.8714 20.7732 33.9653 20.7732V19.1132C32.9547 19.1132 32.1353 19.9326 32.1353 20.9432H33.7953Z",
    strokeWidth: "0",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.11 88.9228C113.11 96.6923 107.075 102.932 99.7016 102.932C92.3284 102.932 86.2934 96.6923 86.2934 88.9228C86.2934 81.1533 92.3284 74.914 99.7016 74.914C107.075 74.914 113.11 81.1533 113.11 88.9228Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: "1.66"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "1",
    y1: "-1",
    x2: "15.6307",
    y2: "-1",
    transform: "matrix(-0.500377 0.865807 -0.846965 -0.531648 103.273 82.2233)",
    stroke: "#333333",
    strokeWidth: "1.66",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.112 85.0303C98.112 86.2415 97.18 87.1521 96.1165 87.1521C95.053 87.1521 94.1211 86.2415 94.1211 85.0303C94.1211 83.8192 95.053 82.9086 96.1165 82.9086C97.18 82.9086 98.112 83.8192 98.112 85.0303Z",
    stroke: "#333333",
    strokeWidth: "1.66",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.128 93.5005C106.128 94.7116 105.196 95.6223 104.132 95.6223C103.069 95.6223 102.137 94.7116 102.137 93.5005C102.137 92.2893 103.069 91.3787 104.132 91.3787C105.196 91.3787 106.128 92.2893 106.128 93.5005Z",
    stroke: "#333333",
    strokeWidth: "1.66",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 21.7716 8.07327)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 21.7716 8.07327)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 21.7716 8.07327)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 33.1415 11.255)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 33.1415 11.255)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 33.1415 11.255)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 34.8663 27.334)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 34.8663 27.334)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 34.8663 27.334)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 24.7675 35.1341)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 24.7675 35.1341)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 24.7675 35.1341)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 22.7384 17.914)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 22.7384 17.914)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 22.7384 17.914)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 12.3678 14.0933)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 12.3678 14.0933)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 12.3678 14.0933)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 13.5026 36.1144)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 13.5026 36.1144)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 13.5026 36.1144)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 18.2325 28.0304)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 18.2325 28.0304)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 18.2325 28.0304)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 7.19592 25.4151)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 7.19592 25.4151)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "2.47014",
    ry: "2.42445",
    transform: "matrix(0.507746 0.861507 -0.842221 0.539133 7.19592 25.4151)",
    stroke: "#43EE91",
    fill: "#43EE91"
  }));
};